import { useCallback } from 'react';
import axiosInstance from '../../../axiosInstance';
import { PRIVILEGE_TYPES } from '../../../constants/role.constant';

/**
 * API hook for privileges-related operations
 */
const usePrivilegesApi = () => {
  /**
   * Fetches all privileges based on type (internal/external)
   * @param {string} privilegeType - PRIVILEGE_TYPES.INTERNAL or PRIVILEGE_TYPES.EXTERNAL
   * @returns {Promise<Array>} List of privileges
   */
  const getPrivileges = useCallback(async (privilegeType) => {
    const query =
      privilegeType === PRIVILEGE_TYPES.INTERNAL
        ? 'is_internal=true'
        : 'is_external=true';
    const response = await axiosInstance.get(`/api/privileges?${query}`);
    return response.data;
  }, []);

  return { getPrivileges };
};

export default usePrivilegesApi;
